export default __webpack_public_path__ + "static/media/bench-window-back-rounded-corners.31e0c663.webp";